import languageNameInterpolations from 'pidgin.js/dist/interpolations.js';
import configService from 'src/libs/configService';
import { getLanguageNameMapping, getLocaleData } from './localeMapping';

const myAppConfig = {
  getMyConfig: function() {
    myAppConfig.config = myAppConfig.config || configService();
    return myAppConfig.config;
  },
  resetMyConfig: function() {
    myAppConfig.config = null;
  },
  getDeviceType: function() {
    switch (myAppConfig.getMyConfig().client.osName) {
      case 'iOS':
        return 'ios';
      case 'Android':
        return 'android';
      default:
        return 'default';
    }
  }
};

const ppfConfig = {
  config: {},
  getEnvironment: function() {
    return myAppConfig.getMyConfig().environment;
  },
  getLearningLanguage: function() {
    return ppfConfig.config.learningLanguage;
  },
  getLanguageTranslation: function(learnLanguageAlpha3 = ppfConfig.getLearningLanguage()) {
    const { locale } = myAppConfig.getMyConfig();
    const localeFullName = getLanguageNameMapping(locale);
    return languageNameInterpolations({ locale, learnLanguageAlpha3 })[localeFullName];
  },
  interpolateLanguage: function(interpolationKey) {
    return languageNameInterpolations({
      locale: myAppConfig.getMyConfig().locale,
      learnLanguageAlpha3: ppfConfig.getLearningLanguage()
    })[interpolationKey];
  },
  setLearningLanguage: function(learningLanguage) {
    ppfConfig.config.learningLanguage = learningLanguage;
  },
  getFlowId: function() {
    return ppfConfig.config.flowId;
  },
  setFlowId: function(flowId) {
    ppfConfig.config.flowId = flowId;
  },
  getFlowVersion: function() {
    return ppfConfig.config.flowVersion;
  },
  setFlowVersion: function(flowVersion) {
    ppfConfig.config.flowVersion = flowVersion;
  },
  setParsedNodes: function(parsedNodes) {
    ppfConfig.config.parsedNodes = parsedNodes;
  },
  getParsedNodes: function() {
    return ppfConfig.config.parsedNodes;
  },
  serialize: function() {
    const { locale, geoData } = myAppConfig.getMyConfig();
    return Object.assign(
      { device: myAppConfig.getDeviceType() },
      ppfConfig.config,
      getLocaleData(locale),
      { geoData }
    );
  }
};

export default {
  getMyConfig: myAppConfig.getMyConfig,
  resetMyConfig: myAppConfig.resetMyConfig,
  getDeviceType: myAppConfig.getDeviceType,
  getEnvironment: ppfConfig.getEnvironment,
  getLanguageTranslation: ppfConfig.getLanguageTranslation,
  getLearningLanguage: ppfConfig.getLearningLanguage,
  setLearningLanguage: ppfConfig.setLearningLanguage,
  getFlowId: ppfConfig.getFlowId,
  setFlowId: ppfConfig.setFlowId,
  getFlowVersion: ppfConfig.getFlowVersion,
  setFlowVersion: ppfConfig.setFlowVersion,
  setParsedNodes: ppfConfig.setParsedNodes,
  getParsedNodes: ppfConfig.getParsedNodes,
  serialize: ppfConfig.serialize,
  interpolateLanguage: ppfConfig.interpolateLanguage
};
